
import { AclRoleState } from '../enums';

export const AclRoleStates = [
  { name: 'Active', value: AclRoleState.Active },
  { name: 'Deleted', value: AclRoleState.Deleted },
];
